'use client';

import { __awaiter, __generator } from '../_virtual/_tslib.js';
import React__default, { useRef, useState, useEffect, useMemo, useImperativeHandle } from 'react';
import Form from '../Form/index.js';
import Col from '../LayoutSystem/Col.js';
import Row from '../LayoutSystem/Row.js';
import Avatar from '../Avatar/index.js';
import { EApplyType } from './type.js';
import { colors } from '../Colors/index.js';
import { Container, WrapInfo, Box, WrapLabel, LinkCover } from './styled.css.js';
import Input from '../Input/index.js';
import Textarea from '../TextareaNew/index.js';
import I11lPhoneNumberInput from '../I11lPhoneNumberInput/index.js';
import DragDropResumeUpload from '../DragDropResumeUpload/index.js';
import { getResumeSettingInfo, changeJobTitle, changePhoneNumber } from '../services/resumes/index.js';
import { ELanguage } from '../Utils/constants.js';
import { hrefWowCV } from './helper.js';
import { Paragraph, Span, Anchor } from '../Typography/components/Variant.js';
import translations from './translations.js';
import { IS_REQUIRED_COVER_LETTER, IS_RESUME_ATTACHMENT, HRINSIDER_ATTACH_RESUME_LINK, LIMIT_CHARACTERS, MAX_NUMBER_OF_CV, HTTP_CODE_SUCCESS } from './const.js';
import PopupCVReplace from '../PopupCVReplace/index.js';
import RadioGroup from './components/RadioGroup.js';
import { createTranslator } from '../Utils/helpers.js';
import validateFunctions from '../Form/utils/validators.js';

var ApplyJobsForm = React__default.forwardRef(function (_a, ref) {
    var _b, _c, _d, _e, _f, _g;
    var userInfo = _a.userInfo, jobInfo = _a.jobInfo, popupOption = _a.popupOption, accessToken = _a.accessToken, lang = _a.lang, baseMsUrl = _a.baseMsUrl, baseUrl = _a.baseUrl, _h = _a.utmSourceWowCV, utmSourceWowCV = _h === void 0 ? '' : _h, handleApply = _a.handleApply;
    var formRef = useRef(null);
    var _j = useState(), resumeInfo = _j[0], setResumeInfo = _j[1];
    var _k = useState((_b = userInfo === null || userInfo === void 0 ? void 0 : userInfo.jobTitle) !== null && _b !== void 0 ? _b : ''), jobTitle = _k[0], setJobTitle = _k[1];
    var t = createTranslator({ translations: translations, currentLanguage: lang });
    var _l = useState(0), newResumeId = _l[0], setNewResumeId = _l[1];
    var popupCVReplaceRef = useRef(null);
    var dropFileComponentRef = useRef(null);
    var validator = Form.validator(t);
    var rules = {
        jobTitle: validator.string().require().noSpecialCharsForJobTitle().generate(),
        phone: validator.string().require().internationalPhoneNumber().vnPhoneNumber().generate(),
        coverLetter: (jobInfo === null || jobInfo === void 0 ? void 0 : jobInfo.requiredCoverLetter) === IS_REQUIRED_COVER_LETTER
            ? validator.string().require().generate()
            : undefined,
        resume: validator
            .string()
            .custom(function (value) {
            if (typeof value.id !== 'number' || (value === null || value === void 0 ? void 0 : value.id) <= 0) {
                return false;
            }
            return true;
        }, t('Please upload your attached CV to apply'))
            .generate(),
        resumeFile: validator
            .string()
            .custom(function (_, watch) {
            if (typeof (watch === null || watch === void 0 ? void 0 : watch.resume.id) !== 'number' || (watch === null || watch === void 0 ? void 0 : watch.resume.id) <= 0) {
                return false;
            }
            return true;
        }, t('Please upload your attached CV to apply'))
            .generate()
    };
    // api user , resume
    var getResume = function () { return __awaiter(void 0, void 0, void 0, function () {
        var resumeSettingInfo, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, getResumeSettingInfo(accessToken, baseMsUrl !== null && baseMsUrl !== void 0 ? baseMsUrl : '', lang)];
                case 1:
                    resumeSettingInfo = _a.sent();
                    if (resumeSettingInfo && resumeSettingInfo) {
                        setResumeInfo(resumeSettingInfo);
                        return [2 /*return*/];
                    }
                    return [3 /*break*/, 3];
                case 2:
                    error_1 = _a.sent();
                    console.error(error_1);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var updateJobTitle = function (value) { return __awaiter(void 0, void 0, void 0, function () {
        var update, error_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, changeJobTitle({
                            baseUrl: baseMsUrl !== null && baseMsUrl !== void 0 ? baseMsUrl : '',
                            accessToken: accessToken,
                            langCode: lang !== null && lang !== void 0 ? lang : ELanguage.VI,
                            value: value
                        })];
                case 1:
                    update = _a.sent();
                    if (update && update.data) {
                        setJobTitle(value);
                        return [2 /*return*/];
                    }
                    return [3 /*break*/, 3];
                case 2:
                    error_2 = _a.sent();
                    console.error(error_2);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var handleFileUpload = function (uploadFileField) { return function (file) { return __awaiter(void 0, void 0, void 0, function () {
        var data;
        var _a, _b, _c, _d, _e;
        return __generator(this, function (_f) {
            switch (_f.label) {
                case 0:
                    if (!((resumeInfo === null || resumeInfo === void 0 ? void 0 : resumeInfo.data) &&
                        ((_b = (_a = resumeInfo === null || resumeInfo === void 0 ? void 0 : resumeInfo.data) === null || _a === void 0 ? void 0 : _a.attributes) === null || _b === void 0 ? void 0 : _b.filter(function (cv) { return !!cv.isAttach; }).length) >= MAX_NUMBER_OF_CV &&
                        popupCVReplaceRef.current)) return [3 /*break*/, 2];
                    return [4 /*yield*/, popupCVReplaceRef.current.open()];
                case 1:
                    data = (_f.sent()).data;
                    if (!data.resumeId) {
                        (_c = dropFileComponentRef.current) === null || _c === void 0 ? void 0 : _c.reset(); // allow popup to trigger again if user drop the same file after cancel replacement request
                        uploadFileField.onChange(null);
                        return [2 /*return*/];
                    }
                    (_d = dropFileComponentRef === null || dropFileComponentRef === void 0 ? void 0 : dropFileComponentRef.current) === null || _d === void 0 ? void 0 : _d.doUploadFile(file, data === null || data === void 0 ? void 0 : data.resumeId);
                    return [3 /*break*/, 3];
                case 2:
                    (_e = dropFileComponentRef === null || dropFileComponentRef === void 0 ? void 0 : dropFileComponentRef.current) === null || _e === void 0 ? void 0 : _e.doUploadFile(file);
                    _f.label = 3;
                case 3: return [2 /*return*/];
            }
        });
    }); }; };
    var onUploadDone = function (response) {
        var _a, _b;
        getResume();
        if ((response === null || response === void 0 ? void 0 : response.code) === HTTP_CODE_SUCCESS) {
            setNewResumeId((_b = (_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.id) !== null && _b !== void 0 ? _b : 0);
        }
    };
    var updatePhone = function (value) { return __awaiter(void 0, void 0, void 0, function () {
        var update, error_3;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, changePhoneNumber({
                            accessToken: accessToken !== null && accessToken !== void 0 ? accessToken : '',
                            baseUrl: baseMsUrl !== null && baseMsUrl !== void 0 ? baseMsUrl : '',
                            langCode: lang !== null && lang !== void 0 ? lang : ELanguage.VI,
                            value: value !== null && value !== void 0 ? value : ''
                        })];
                case 1:
                    update = _a.sent();
                    if (update && update.data) {
                        return [2 /*return*/];
                    }
                    return [3 /*break*/, 3];
                case 2:
                    error_3 = _a.sent();
                    console.error(error_3);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    useEffect(function () {
        if (accessToken) {
            getResume();
        }
    }, [accessToken]);
    // submit form
    var defaultResumeValue = useMemo(function () {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r;
        if (!((_a = resumeInfo === null || resumeInfo === void 0 ? void 0 : resumeInfo.data) === null || _a === void 0 ? void 0 : _a.profileSetting))
            return null;
        var latestAttachResumeId = (_e = (_d = (_c = (_b = resumeInfo === null || resumeInfo === void 0 ? void 0 : resumeInfo.data) === null || _b === void 0 ? void 0 : _b.attributes) === null || _c === void 0 ? void 0 : _c.filter(function (e) { return (e === null || e === void 0 ? void 0 : e.isAttach) === 1; })[0]) === null || _d === void 0 ? void 0 : _d.id) !== null && _e !== void 0 ? _e : 0;
        var latestAppliedResume = (_h = (_g = (_f = resumeInfo === null || resumeInfo === void 0 ? void 0 : resumeInfo.data) === null || _f === void 0 ? void 0 : _f.attributes) === null || _g === void 0 ? void 0 : _g.filter(function (e) { return (e === null || e === void 0 ? void 0 : e.isLastApplied) === true; })[0]) !== null && _h !== void 0 ? _h : null;
        var onlineResumeId = (_m = (_l = (_k = (_j = resumeInfo === null || resumeInfo === void 0 ? void 0 : resumeInfo.data) === null || _j === void 0 ? void 0 : _j.attributes) === null || _k === void 0 ? void 0 : _k.find(function (e) { return (e === null || e === void 0 ? void 0 : e.isAttach) === 0; })) === null || _l === void 0 ? void 0 : _l.id) !== null && _m !== void 0 ? _m : 0;
        // priority 1: checked upload new file
        if (newResumeId > 0) {
            return {
                type: EApplyType.lastAttachment,
                resumeId: (_r = (_q = (_p = (_o = resumeInfo === null || resumeInfo === void 0 ? void 0 : resumeInfo.data) === null || _o === void 0 ? void 0 : _o.attributes) === null || _p === void 0 ? void 0 : _p.filter(function (e) { return (e === null || e === void 0 ? void 0 : e.isAttach) === 1 && (e === null || e === void 0 ? void 0 : e.id) === newResumeId; })[0]) === null || _q === void 0 ? void 0 : _q.id) !== null && _r !== void 0 ? _r : 0
            };
        }
        // priority 2: checked last Applied
        // if attachment, priority last updated
        if (latestAppliedResume) {
            return {
                type: (latestAppliedResume === null || latestAppliedResume === void 0 ? void 0 : latestAppliedResume.isAttach) == IS_RESUME_ATTACHMENT
                    ? EApplyType.lastAttachment
                    : EApplyType.online,
                resumeId: (latestAppliedResume === null || latestAppliedResume === void 0 ? void 0 : latestAppliedResume.isAttach) == IS_RESUME_ATTACHMENT ? latestAttachResumeId : onlineResumeId
            };
        }
        // At least one valid profile
        // priority 3: checked last updated resume attachment if it valid, else online profile
        if (latestAttachResumeId) {
            return {
                type: EApplyType.lastAttachment,
                resumeId: latestAttachResumeId
            };
        }
        if (resumeInfo.data.searchableStatus) {
            var isProfileAllowSearchable = resumeInfo.data.attributes.find(function (e) { return e.isAttach !== IS_RESUME_ATTACHMENT && e.allowSearchableDisplay === 1; });
            if (isProfileAllowSearchable) {
                return {
                    type: EApplyType.online,
                    resumeId: onlineResumeId
                };
            }
        }
        // none resume
        return {
            type: EApplyType.lastAttachment,
            resumeId: 0
        };
    }, [resumeInfo]);
    var formData = {
        jobTitle: jobTitle,
        phone: userInfo === null || userInfo === void 0 ? void 0 : userInfo.phone,
        coverLetter: '',
        resume: {
            type: defaultResumeValue === null || defaultResumeValue === void 0 ? void 0 : defaultResumeValue.type,
            id: defaultResumeValue === null || defaultResumeValue === void 0 ? void 0 : defaultResumeValue.resumeId
        },
        tempAttachResumeId: (_e = (_d = (_c = resumeInfo === null || resumeInfo === void 0 ? void 0 : resumeInfo.data) === null || _c === void 0 ? void 0 : _c.attributes.filter(function (item) { return item.isAttach === 1; })[0]) === null || _d === void 0 ? void 0 : _d.id) !== null && _e !== void 0 ? _e : null,
        resumeFile: null,
        isReplaced: null,
        attachLink: null
    };
    var onSubmit = function () {
        var _a;
        (_a = formRef.current) === null || _a === void 0 ? void 0 : _a.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
    };
    // render custom element & styling
    var settingCol = function (size) {
        if (popupOption === null || popupOption === void 0 ? void 0 : popupOption.isInPopup) {
            return;
        }
        return size;
    };
    var settingRow = !(popupOption === null || popupOption === void 0 ? void 0 : popupOption.isInPopup) ? [24, 16] : [12, 8];
    useImperativeHandle(ref, function () {
        return {
            onSubmit: onSubmit
        };
    }, []);
    return (React__default.createElement(Container, { isInPopup: popupOption === null || popupOption === void 0 ? void 0 : popupOption.isInPopup },
        React__default.createElement(Form, { ref: formRef, initialValues: formData, onSubmit: function (values) {
                handleApply && handleApply(values);
            } },
            React__default.createElement(Row, { gutter: settingRow, align: 'middle', justify: 'center' },
                (popupOption === null || popupOption === void 0 ? void 0 : popupOption.isInPopup) ? null : (React__default.createElement(Col, null,
                    React__default.createElement(WrapInfo, null,
                        React__default.createElement(Avatar, { image: (_f = userInfo === null || userInfo === void 0 ? void 0 : userInfo.profilePicture) !== null && _f !== void 0 ? _f : '' }),
                        React__default.createElement(Paragraph, { color: colors.grey[20], name: 'title', size: 'medium' }, userInfo === null || userInfo === void 0 ? void 0 :
                            userInfo.firstName,
                            " ", userInfo === null || userInfo === void 0 ? void 0 :
                            userInfo.lastName)))),
                React__default.createElement(Col, null,
                    React__default.createElement(Box, { display: (popupOption === null || popupOption === void 0 ? void 0 : popupOption.isInPopup) ? 'grid' : 'block' },
                        (popupOption === null || popupOption === void 0 ? void 0 : popupOption.isInPopup) && React__default.createElement(Avatar, { image: (_g = userInfo === null || userInfo === void 0 ? void 0 : userInfo.profilePicture) !== null && _g !== void 0 ? _g : '' }),
                        React__default.createElement(Row, { gutter: settingRow },
                            (popupOption === null || popupOption === void 0 ? void 0 : popupOption.isInPopup) && (React__default.createElement(Col, null,
                                React__default.createElement(Paragraph, { color: colors.grey[20], name: 'title', size: 'medium' }, userInfo === null || userInfo === void 0 ? void 0 :
                                    userInfo.firstName,
                                    " ", userInfo === null || userInfo === void 0 ? void 0 :
                                    userInfo.lastName))),
                            React__default.createElement(Form.Item, { name: 'jobTitle', rules: rules.jobTitle }, function (field) {
                                return (React__default.createElement(Col, { md: settingCol(12), xs: 24 },
                                    (popupOption === null || popupOption === void 0 ? void 0 : popupOption.isInPopup) ? null : (React__default.createElement(Form.Label, null, t('Job Title'))),
                                    React__default.createElement(Input, { value: field.value, onChange: function (value) {
                                            field.onChange(value);
                                        }, onBlur: function () {
                                            field.onBlur();
                                            var validateNoNumberAndEmail = validateFunctions.validateNoNumberAndEmail, validateNoSpecialCharsForJobTitle = validateFunctions.validateNoSpecialCharsForJobTitle;
                                            if (field.value && typeof field.value === 'string') {
                                                var validJobTitle = !validateNoNumberAndEmail(field.value) &&
                                                    !validateNoSpecialCharsForJobTitle(field.value);
                                                validJobTitle ? updateJobTitle(field.value) : undefined;
                                            }
                                        }, hasError: field.isError, placeholder: t('Enter job title') }),
                                    React__default.createElement(Form.Error, null)));
                            }),
                            React__default.createElement(Form.Item, { name: 'phone', rules: rules.phone }, function (field) {
                                return (React__default.createElement(Col, { md: settingCol(12), xs: 24 },
                                    (popupOption === null || popupOption === void 0 ? void 0 : popupOption.isInPopup) ? null : (React__default.createElement(Form.Label, null, t('Phone'))),
                                    React__default.createElement(I11lPhoneNumberInput, { value: field.value, onChange: field.onChange, onBlur: function () {
                                            field.onBlur();
                                            if (field.value && !field.isError) {
                                                updatePhone(field.value);
                                            }
                                        }, hasError: field.isError, placeholder: t('Enter phone number'), floatingConfig: {
                                            position: 'fixed',
                                            enablePortal: true,
                                            useWindowAsFlippingContainer: true
                                        } }),
                                    React__default.createElement(Form.Error, null)));
                            })))),
                (jobInfo === null || jobInfo === void 0 ? void 0 : jobInfo.requiredCoverLetter) && (jobInfo === null || jobInfo === void 0 ? void 0 : jobInfo.requiredCoverLetter) !== 0 ? (React__default.createElement(Form.Item, { name: 'coverLetter', rules: rules.coverLetter }, function (field) {
                    return (React__default.createElement(Col, null,
                        React__default.createElement(WrapLabel, null,
                            React__default.createElement(Form.Label, null, t('Cover letter')),
                            React__default.createElement(LinkCover, { href: HRINSIDER_ATTACH_RESUME_LINK, target: '_blank', color: colors.primary[40], name: 'body', size: 'small' }, t('View sample'))),
                        React__default.createElement(Textarea, { hasError: field.isError, placeholder: t('Enter cover letter'), maxLength: LIMIT_CHARACTERS, onChange: field.onChange, onBlur: field.onBlur }),
                        React__default.createElement(Form.Error, null)));
                })) : null,
                React__default.createElement(Form.Item, { name: 'isReplaced' }, function (field) {
                    var _a;
                    return (React__default.createElement(PopupCVReplace, { ref: popupCVReplaceRef, langCode: lang, formControl: field, maxNumberOfCV: MAX_NUMBER_OF_CV, cvList: ((_a = resumeInfo === null || resumeInfo === void 0 ? void 0 : resumeInfo.data) === null || _a === void 0 ? void 0 : _a.attributes) || [] }));
                }),
                React__default.createElement(Form.Item, { name: 'resume', rules: rules.resume, watch: ['resumeFile', 'tempAttachResumeId', 'attachLink', 'isReplaced'] }, function (field) {
                    var _a, _b, _c, _d;
                    return (React__default.createElement(Col, null,
                        React__default.createElement(Form.Label, { require: !((_a = field.value) === null || _a === void 0 ? void 0 : _a.type) },
                            (((_b = resumeInfo === null || resumeInfo === void 0 ? void 0 : resumeInfo.data) === null || _b === void 0 ? void 0 : _b.attributes) && (resumeInfo === null || resumeInfo === void 0 ? void 0 : resumeInfo.data.attributes.length) > 0) ||
                                ((_c = field.watch) === null || _c === void 0 ? void 0 : _c.resumeFile) ? (React__default.createElement(Span, { name: 'title', size: 'small', color: colors.grey[20] },
                                t('Choose a profile to apply'),
                                ":",
                                ' ')) : (React__default.createElement(Span, { name: 'title', size: 'small', color: colors.grey[20] },
                                t('Upload your attached CV to apply'),
                                ":",
                                ' ')),
                            (jobInfo === null || jobInfo === void 0 ? void 0 : jobInfo.languageSelectedId) && (jobInfo === null || jobInfo === void 0 ? void 0 : jobInfo.languageSelectedId) !== 3 ? (React__default.createElement(React__default.Fragment, null,
                                React__default.createElement(Span, { name: 'body', size: 'medium' },
                                    t('Employers prefer to receive your resume in'),
                                    ' '),
                                React__default.createElement(Span, { name: 'title', size: 'small' }, lang === ELanguage.VI
                                    ? jobInfo === null || jobInfo === void 0 ? void 0 : jobInfo.languageSelectedVI
                                    : jobInfo === null || jobInfo === void 0 ? void 0 : jobInfo.languageSelected))) : null),
                        React__default.createElement(RadioGroup, { field: field, resumeSettingInfo: resumeInfo === null || resumeInfo === void 0 ? void 0 : resumeInfo.data, t: t, newAttach: (_d = field.watch) === null || _d === void 0 ? void 0 : _d.resumeFile, baseUrl: baseUrl !== null && baseUrl !== void 0 ? baseUrl : '', baseMsUrl: baseMsUrl !== null && baseMsUrl !== void 0 ? baseMsUrl : '', accessToken: accessToken, lang: lang, newResumeId: newResumeId })));
                }),
                React__default.createElement(Form.Item, { name: 'resumeFile', rules: rules.resumeFile, watch: ['tempAttachResumeId', 'resume'] }, function (field) {
                    var _a, _b;
                    return (React__default.createElement(Col, null,
                        React__default.createElement(DragDropResumeUpload, { lang: lang, accessToken: accessToken, ref: dropFileComponentRef, baseUrl: baseMsUrl, isCheckSpam: true, onUpload: handleFileUpload(field), isLoading: true, onUploadDone: onUploadDone }),
                        React__default.createElement(Form.Error, { disable: !!((_b = (_a = field.watch) === null || _a === void 0 ? void 0 : _a.resume) === null || _b === void 0 ? void 0 : _b.id) })));
                }),
                React__default.createElement(Col, { xs: 24 },
                    React__default.createElement(Row, { gutter: settingRow, align: 'middle' },
                        React__default.createElement(Col, { xs: 24 },
                            React__default.createElement(Anchor, { href: hrefWowCV({
                                    source: utmSourceWowCV !== null && utmSourceWowCV !== void 0 ? utmSourceWowCV : '',
                                    langCode: lang !== null && lang !== void 0 ? lang : ELanguage.VI,
                                    baseUrl: baseUrl !== null && baseUrl !== void 0 ? baseUrl : ''
                                }), target: '_blank', color: colors.primary[40], name: 'body', size: 'small', style: { textAlign: 'right', display: 'block' } }, t('Create attracted CV with WowCV')))))),
            React__default.createElement("button", { type: 'submit', hidden: true }, "submit"))));
});
var ApplyJobsForm$1 = React__default.memo(ApplyJobsForm);

export { ApplyJobsForm$1 as default };
//# sourceMappingURL=index.js.map
